import apiRequest from "../../helpers/apiRequest";

export default async (body) => {
    return await apiRequest({
        method: 'post',
        url: `content/create/group/session/`,
        data: body
    })
}
